// extracted by mini-css-extract-plugin
module.exports = {"signInContainer":"SignIn_signInContainer__2UKlK","signInSection":"SignIn_signInSection__28RIg"};